/**
 * Kullanıcı profil bileşeni 
 * Sidebar'da görüntülenir ve kullanıcının temel bilgilerini içerir
 */

import { authService, userService, generateProfilePicture } from '../services/firebase.js';
import { updateProfile } from 'firebase/auth';

export default class UserProfile {
  constructor(container) {
    this.container = container;
    this.currentUser = null;
    
    this.render();
    this.attachEventListeners();
  }
  
  setUser(user) {
    this.currentUser = user;
    this.render();
  }
  
  async render() {
    if (!this.currentUser) {
      this.container.innerHTML = `
        <div class="profile-placeholder">
          <div class="spinner"></div>
        </div>
      `;
      return;
    }
    
    try {
      //console.log("Profil render ediliyor. User:", this.currentUser.uid);
      const userProfile = await userService.getUserProfile(this.currentUser.uid);
      //console.log("Alınan profil:", userProfile);
      
      // Kullanıcı profili bulunamadıysa basit görünüm göster
      if (!userProfile) {
        //console.warn("UserProfile render: Profil bilgisi bulunamadı!");
        this.container.innerHTML = `
          <div class="profile-avatar">
            <img src='${generateProfilePicture(this.currentUser.displayName)}' alt="Kullanıcı" 
              onerror="this.onerror=null; this.src='${generateProfilePicture(this.currentUser.email.split('@')[0])}'">
          </div>
          <div class="profile-info">
            <div class="profile-name">${this.currentUser.email}</div>
            <div class="profile-user-code">Kullanıcı Kodu: Yükleniyor...</div>
          </div>
          <div class="profile-actions">
            <button id="logout-btn" class="profile-button" title="Çıkış Yap">
              <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4"></path>
                <polyline points="16 17 21 12 16 7"></polyline>
                <line x1="21" y1="12" x2="9" y2="12"></line>
              </svg>
            </button>
          </div>
        `;
        return;
      }
      
      // Çevrimdışı yalnızca çıkışta otomatik ayarlanır; kullanıcı manuel seçemez
      const statuses = ['Çevrimiçi', 'Meşgul', 'Uzakta'];
      
      // Kullanıcı kodu ve rolünü al
      const userCode = userProfile?.code || userProfile?.userCode || 'Tanımlanmamış';
      const userRole = userProfile?.userRole || 'user';
      
      //console.log("Görüntülenecek kod:", userCode);
      //console.log("Görüntülenecek rol:", userRole);
      
      // Rol adını güzelleştir
      let formattedRole = '';
      if (userRole) {
        if (userRole.toLowerCase() === 'admin') {
          formattedRole = 'Admin';
        } else if (userRole.toLowerCase() === 'control') {
          formattedRole = 'Control';
        } else {
          formattedRole = userRole.charAt(0).toUpperCase() + userRole.slice(1);
        }
      }
      
      // Kullanıcı adını belirle - authDb'den gelir
      const userName = userProfile?.displayName || this.currentUser.displayName || this.currentUser.email.split('@')[0];
      
      // Kullanıcı kod ve rolünü göster
      const userCodeDisplay = `${userCode} (${formattedRole})`;
      
      // Gradient için displayName değeri
      const displayName = userProfile?.displayName || this.currentUser.displayName || userName;
      
      this.container.innerHTML = `
        <div class="profile-avatar">
          <img src="${userProfile?.photoURL || generateProfilePicture(this.currentUser.displayName)}" alt="${displayName}" 
            onerror="this.onerror=null; this.src='${displayName ? generateProfilePicture(displayName) : generateProfilePicture(this.currentUser.displayName)}'">
        </div>
        <div class="profile-info">
          <div class="profile-name">${userName}</div>
          <div class="profile-user-code">${userCodeDisplay}</div>
          <div class="profile-status-container">
            <span class="profile-status">${userProfile?.status || 'Çevrimiçi'}</span>
            <div class="status-dropdown">
              <button class="status-dropdown-toggle">
                <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                  <polyline points="6 9 12 15 18 9"></polyline>
                </svg>
              </button>
              <div class="status-dropdown-menu hidden">
                ${statuses.map(status => `
                  <div class="status-option" data-status="${status}">
                    <span class="status-indicator status-${status.toLowerCase()}"></span>
                    <span class="status-text">${status}</span>
                  </div>
                `).join('')}
              </div>
            </div>
          </div>
        </div>
        <div class="profile-actions">
          <button id="profile-edit-btn" class="profile-button" title="Profili Düzenle">
            <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
              <path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7"></path>
              <path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z"></path>
            </svg>
          </button>
          <button id="logout-btn" class="profile-button" title="Çıkış Yap">
            <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
              <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4"></path>
              <polyline points="16 17 21 12 16 7"></polyline>
              <line x1="21" y1="12" x2="9" y2="12"></line>
            </svg>
          </button>
        </div>
      `;
      
      // CSS için ek stillemeler
      const style = document.createElement('style');
      if (!document.querySelector('style#profile-styles')) {
        style.id = 'profile-styles';
        style.textContent = `
          .profile-user-code {
            font-size: 0.85em;
            color: var(--text-secondary);
            margin-bottom: 4px;
          }
          
          .profile-status-container {
            display: flex;
            align-items: center;
            position: relative;
          }
          
          .status-dropdown-toggle {
            padding: 2px;
            margin-left: 4px;
            display: flex;
            align-items: center;
            opacity: 0.7;
          }
          
          .status-dropdown-menu {
            position: absolute;
            top: 100%;
            left: 0;
            background-color: var(--bg-secondary);
            border-radius: var(--radius-md);
            box-shadow: var(--shadow-md);
            width: 150px;
            z-index: 10;
            overflow: hidden;
          }
          
          .status-option {
            padding: 8px 12px;
            display: flex;
            align-items: center;
            cursor: pointer;
            transition: var(--transition-fast);
          }
          
          .status-option:hover {
            background-color: var(--bg-hover);
          }
          
          .status-indicator {
            width: 8px;
            height: 8px;
            border-radius: 50%;
            margin-right: 8px;
          }
          
          .status-çevrimiçi { background-color: #4caf50; }
          .status-meşgul { background-color: #f44336; }
          .status-uzakta { background-color: #ff9800; }
          .status-çevrimdışı { background-color: #9e9e9e; }
          
          .profile-actions {
            display: flex;
            gap: 8px;
          }
          
          .profile-button {
            width: 32px;
            height: 32px;
            border-radius: 50%;
            display: flex;
            align-items: center;
            justify-content: center;
            color: var(--text-secondary);
            transition: var(--transition-fast);
          }
          
          .profile-button:hover {
            background-color: var(--bg-hover);
            color: var(--text-primary);
          }
        `;
        document.head.appendChild(style);
      }
    } catch (error) {
      //console.error('Profil görüntülenirken hata:', error);
      // Hata durumunda basit bir görünüm göster
      this.container.innerHTML = `
        <div class="profile-error">
          <div class="error-message">Profil yüklenirken bir hata oluştu.</div>
          <button id="logout-btn" class="profile-button" title="Çıkış Yap">
            <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
              <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4"></path>
              <polyline points="16 17 21 12 16 7"></polyline>
              <line x1="21" y1="12" x2="9" y2="12"></line>
            </svg>
          </button>
        </div>
      `;
    }
    
    // İçerikten sonra event listener'ları yeniden bağla
    this.attachEventListeners();
  }
  
  attachEventListeners() {
    // Durum değiştirme arayüzü
    const statusToggle = this.container.querySelector('.status-dropdown-toggle');
    const statusMenu = this.container.querySelector('.status-dropdown-menu');
    
    if (statusToggle && statusMenu) {
      statusToggle.addEventListener('click', () => {
        statusMenu.classList.toggle('hidden');
      });
      
      // Dışarı tıklandığında menüyü kapat
      document.addEventListener('click', (e) => {
        if (!statusToggle.contains(e.target) && !statusMenu.contains(e.target)) {
          statusMenu.classList.add('hidden');
        }
      });
      
      // Durum seçenekleri
      const statusOptions = this.container.querySelectorAll('.status-option');
      statusOptions.forEach(option => {
        option.addEventListener('click', async () => {
          const status = option.getAttribute('data-status');
          if (this.currentUser) {
            await userService.updateUserStatus(this.currentUser.uid, status);
            this.render(); // Profili yenile
            statusMenu.classList.add('hidden');
          }
        });
      });
    }
    
    // Çıkış yapma
    const logoutButton = this.container.querySelector('#logout-btn');
    if (logoutButton) {
      logoutButton.addEventListener('click', async () => {
        try {
          await authService.logout();
          // Çıkış işlemi başarılı, ana sayfa durumu güncellenecek
        } catch (error) {
          //console.error('Çıkış yaparken hata:', error);
        }
      });
    }
    
    // Profil düzenleme
    const profileEditButton = this.container.querySelector('#profile-edit-btn');
    if (profileEditButton) {
      profileEditButton.addEventListener('click', () => {
        this.showProfileEditModal();
      });
    }
  }
  
  showProfileEditModal() {
    // Önce varsa eski modalı kaldır
    const existingModal = document.querySelector('.profile-edit-modal');
    if (existingModal) {
      existingModal.remove();
    }
    
    // Profil düzenleme modalını oluştur
    const modal = document.createElement('div');
    modal.className = 'profile-edit-modal';
    
    // Kullanıcı profilini getir
    userService.getUserProfile(this.currentUser.uid).then(userProfile => {
      // Kullanıcı kodu ve rolünü al
      const userCode = userProfile?.code || userProfile?.userCode || '';
      const userRole = userProfile?.userRole || '';
      
      modal.innerHTML = `
        <div class="modal-overlay"></div>
        <div class="modal-container">
          <div class="modal-header">
            <h3>Profili Düzenle</h3>
            <button class="modal-close-btn">
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                <line x1="18" y1="6" x2="6" y2="18"></line>
                <line x1="6" y1="6" x2="18" y2="18"></line>
              </svg>
            </button>
          </div>
          <div class="modal-body">
            <div class="profile-photo-edit">
              <div class="profile-photo-preview">
                <img src="${this.currentUser?.photoURL || generateProfilePicture(this.currentUser.displayName)}" alt="Profil Fotoğrafı" onerror="this.onerror=null; this.src='${this.currentUser?.displayName ? generateProfilePicture(this.currentUser.displayName) : generateProfilePicture(this.currentUser.displayName)}'">
              </div>
              <div class="profile-photo-buttons">
                <button id="change-photo-btn" class="action-btn">Fotoğraf Değiştir</button>
                <input type="file" id="photo-upload" accept="image/*" style="display: none;">
              </div>
            </div>
            
            <div class="input-group">
              <label for="edit-display-name" class="input-label">Kullanıcı Adı</label>
              <input type="text" id="edit-display-name" class="input-field" value="${this.currentUser?.displayName || ''}">
            </div>
            
            <div class="user-info-display">
              <div class="info-item">
                <span class="info-label">Kullanıcı Kodu:</span>
                <span class="info-value">${userCode}</span>
              </div>
              ${userRole ? `
              <div class="info-item">
                <span class="info-label">Kullanıcı Rolü:</span>
                <span class="info-value">${userRole.charAt(0).toUpperCase() + userRole.slice(1)}</span>
              </div>
              ` : ''}
            </div>
          </div>
          <div class="modal-footer">
            <button id="cancel-edit-btn" class="btn-secondary">İptal</button>
            <button id="save-profile-btn" class="btn-primary">Kaydet</button>
          </div>
        </div>
      `;
      
      // CSS için ek stillemeler
      const style = document.createElement('style');
      if (!document.querySelector('style#modal-styles')) {
        style.id = 'modal-styles';
        style.textContent = `
          .profile-edit-modal {
            position: fixed;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
            z-index: 1000;
            display: flex;
            align-items: center;
            justify-content: center;
          }
          
          .modal-overlay {
            position: absolute;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
            background-color: rgba(0, 0, 0, 0.5);
          }
          
          .modal-container {
            background-color: var(--bg-secondary);
            border-radius: var(--radius-lg);
            width: 90%;
            max-width: 400px;
            z-index: 1001;
            box-shadow: var(--shadow-lg);
            overflow: hidden;
          }
          
          .modal-header {
            padding: var(--space-md);
            border-bottom: 1px solid var(--bg-tertiary);
            display: flex;
            justify-content: space-between;
            align-items: center;
          }
          
          .modal-body {
            padding: var(--space-lg);
          }
          
          .modal-footer {
            padding: var(--space-md);
            border-top: 1px solid var(--bg-tertiary);
            display: flex;
            justify-content: flex-end;
            gap: var(--space-sm);
          }
          
          .profile-photo-edit {
            display: flex;
            flex-direction: column;
            align-items: center;
            margin-bottom: var(--space-lg);
          }
          
          .profile-photo-preview {
            width: 100px;
            height: 100px;
            border-radius: 50%;
            overflow: hidden;
            margin-bottom: var(--space-md);
          }
          
          .profile-photo-preview img {
            width: 100%;
            height: 100%;
            object-fit: cover;
          }
          
          .action-btn {
            padding: var(--space-xs) var(--space-md);
            background-color: var(--bg-tertiary);
            border-radius: var(--radius-sm);
            color: var(--text-primary);
          }
          
          .btn-primary {
            padding: var(--space-xs) var(--space-md);
            background-color: var(--bg-accent);
            color: white;
            border-radius: var(--radius-sm);
            font-weight: 500;
          }
          
          .btn-secondary {
            padding: var(--space-xs) var(--space-md);
            background-color: var(--bg-tertiary);
            color: var(--text-primary);
            border-radius: var(--radius-sm);
          }
          
          .user-info-display {
            margin-top: var(--space-md);
            padding: var(--space-md);
            background-color: var(--bg-tertiary);
            border-radius: var(--radius-md);
          }
          
          .info-item {
            display: flex;
            justify-content: space-between;
            padding: var(--space-xs) 0;
          }
          
          .info-label {
            font-weight: 500;
            color: var(--text-secondary);
          }
          
          .info-value {
            color: var(--text-primary);
            font-weight: 600;
          }
        `;
        document.head.appendChild(style);
      }
      
      document.body.appendChild(modal);
      
      // Modal event listenerları
      const closeBtn = modal.querySelector('.modal-close-btn');
      const cancelBtn = modal.querySelector('#cancel-edit-btn');
      const photoUploadBtn = modal.querySelector('#change-photo-btn');
      const photoInput = modal.querySelector('#photo-upload');
      const saveProfileBtn = modal.querySelector('#save-profile-btn');
      
      const closeModal = () => {
        modal.remove();
      };
      
      closeBtn.addEventListener('click', closeModal);
      cancelBtn.addEventListener('click', closeModal);
      
      modal.querySelector('.modal-overlay').addEventListener('click', closeModal);
      
      if (photoUploadBtn && photoInput) {
        photoUploadBtn.addEventListener('click', () => {
          photoInput.click();
        });
        
        photoInput.addEventListener('change', (e) => {
          if (e.target.files && e.target.files[0]) {
            const reader = new FileReader();
            
            reader.onload = (event) => {
              modal.querySelector('.profile-photo-preview img').src = event.target.result;
            };
            
            reader.readAsDataURL(e.target.files[0]);
          }
        });
      }
      
      if (saveProfileBtn) {
        saveProfileBtn.addEventListener('click', async () => {
          try {
            // Giriş değerlerini al
            const newDisplayName = modal.querySelector('#edit-display-name').value.trim();
            const file = photoInput.files && photoInput.files[0];
            
            // currentUser kontrolü
            if (!this.currentUser || !this.currentUser.uid) {
              throw new Error('Kullanıcı oturumu bulunamadı');
            }
            
            // Fotoğraf yüklendiyse güncelle
            if (file) {
              await userService.updateProfilePhoto(this.currentUser.uid, file);
            }
            
            // Kullanıcı adı değişti mi kontrol et
            const currentDisplayName = this.currentUser.displayName || '';
            if (newDisplayName && newDisplayName !== currentDisplayName) {
              await userService.updateUserProfile(this.currentUser.uid, { displayName: newDisplayName });
              
              // Auth profili ile Firestore senkronizasyonu için
              if (authService.getCurrentUser()) {
                try {
                  // Firebase Auth profilini güncelle
                  await updateProfile(authService.getCurrentUser(), { 
                    displayName: newDisplayName 
                  });
                } catch (authError) {
                  //console.error('Auth profili güncellenirken hata:', authError);
                  // Kritik bir hata değil, devam edilebilir
                }
              }
            }
            
            // Profili yenile
            this.render();
            closeModal();
          } catch (error) {
            //console.error('Profil güncellenirken hata:', error);
            // Hata mesajını göster
            const errorMsg = document.createElement('div');
            errorMsg.className = 'error-message';
            errorMsg.textContent = 'Profil güncellenirken bir hata oluştu.';
            modal.querySelector('.modal-body').appendChild(errorMsg);
          }
        });
      }
    });
  }
}

export function initUserProfile(user) {
  const profileContainer = document.getElementById('user-profile');
  if (profileContainer) {
    const profileComponent = new UserProfile(profileContainer);
    profileComponent.setUser(user);
    return profileComponent;
  }
  return null;
} 